<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<button type="button" data-toggle="tooltip" title="Отказ" class="btn btn-default" @click="$router.go(-1)"><i class="fa fa-times"></i></button>
					<button type="button" data-toggle="tooltip" title="Публикувай" class="btn btn-success" @click="onSubmit()"><i class="fa fa-save"></i></button>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content-->
	<div class="container-fluid" v-if="dataReady">

		<!-- Basic Info -->
		<div class="card col-12">
			<div class="card-block">

				<f-input v-model="topic.title" name="topic_title" v-validate="'required'" :errors="errorBag.collect('topic_title')">
				</f-input>

				<f-select v-model="topic.section" name="topic_section" :values="sectionValues" v-validate="'required'" :errors="errorBag.collect('topic_section')">
				</f-select>

				<div class="row" v-if="topic.text !== undefined">
					<f-textarea style="height:100%" class="col-6" v-model="topic.text" name="topic_text" v-validate="'required'" :errors="errorBag.collect('topic_text')" :crows="10">
					</f-textarea>
					<div class="col-6">
						<label class="control-label">Преглед</label>
						<vue-markdown :source="topic.text"></vue-markdown>
					</div>
					<div class="col-6">
						Може да форматирате съобщението си като използвате <a href="http://commonmark.org/help/" target="_blank">markdown</a>.
					</div>
				</div>

			</div>
			<!-- end card-block -->
		</div>
		<!-- end card -->
	</div>

</div>
</template>

<script>
var VueMarkdown = require('vue-markdown').default;
var cache = require('./section-cache');
module.exports = {
	data: function() {
		return {
			cache: cache.data,
			dataReady: true,
			topic: undefined
		};
	},
	created: function() {
		this.fetchData();
		cache.prepare(this);
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function() {
			if (!this.$route.params.id) {
				this.topic = {
					title: '',
					text: '',
					section: ''
				};
				this.dataReady = true;
			} else {
				this.$http.get('backend://topic/' + this.$route.params.id).then((result) => {
					this.topic = result.body;
					this.dataReady = true;
				}).catch(this.$http.toastCatcher);
			}
		},
		onSubmit: function() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					this.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				this.$http.putOrPostResource('backend://topic/', this.topic).then((response) => {
					this.$router.replace('/discussion/' + response.body.id);
				}).catch(this.$http.toastCatcher);
			});
		},
	},
	computed: {
		sectionValues () {
			if (!this.cache.dataReady) return {};
			let result = {};
			for (let i in this.cache.sections) {
				if ((this.cache.sections[i].paid || 0) <= (this.$user.familyUser.family.paid || 0)) {
					result[i] = {text: this.cache.sections[i].name};
				}
			}
			return result;
		}
	},
	components: {
		'vue-markdown': VueMarkdown
	}
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// TopicEdit.vue?bc517058